import React from "react";
import theme from "app/Theme/Theme";
import Svg, { ClipPath, Defs, G, Path } from "react-native-svg";
import normalize from "app/utils/normalize";

const TimerIcon = ({
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["neutral.900"],
  ...props
}) => (
  <Svg
    width={width}
    height={height}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 24 24"
    {...props}
  >
    <G clipPath="url(#a)">
      <G clipPath="url(#b)" fill={color}>
        <Path d="M11.9 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm0 16.2a7.2 7.2 0 1 1 0-14.4 7.2 7.2 0 0 1 0 14.4Z" />
        <Path d="M15.4 11.1h-2.7V8.4a.9.9 0 1 0-1.8 0V12a.9.9 0 0 0 .9.9h3.6a.9.9 0 1 0 0-1.8Z" />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
      <ClipPath id="b">
        <Path fill="#fff" transform="translate(-.1)" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
);

export default TimerIcon;
